<template>
  <div >

     <!-- ENCABEZADO --> 

     <!-- PC -->

     <v-layout class="hidden-sm-and-down" row wrap>
      <v-flex sm12 md12 >
        <v-card flat dark color="white">        
          <v-img
              src="cover_home_maestros.png"
            >
            <div class="vertical-center">
              <v-flex xs4 sm4 md5 lg5>
                <p class="text-top-row" style="font-family:Fredoka one;">
                  {{row1_text1}}
                </p>-
                
                <p class="text-top-row" style="font-family:Fredoka one">
                  {{row1_text2}}
                </p>
              </v-flex>
            </div>
            <v-img class="cenefa"
                src="cenefa.png" 
            />          
        </v-img>
        </v-card>
      </v-flex> 
    </v-layout>

    <!-- Movil -->
    <v-layout row wrap class="hidden-md-and-up">
      <v-flex sm12 md12 >
        <v-card flat dark color="white">        
          <v-img class="header_parents"
              src="escuela_cover_mobile-23.png" height="300px"
            >
            <div class="vertical-center-mobile">
              <v-flex xs11 sm11 md4 lg4>
                <p  style="font-size:7vw; font-family:Fredoka one; text-align:center">
                  {{row1_text1}}
                </p>
                <p  style="font-size:5.6vw; margin-top:-4%; font-family:Poppins; text-align:center">
                  {{row1_text2}}
                </p>
                <!--<v-flex xs11 sm11>
                <p style="font-size:5.5vw;margin-top:-4%; font-family:Poppins; font-weight:600; text-align:center">
                  {{row1_text2}}
                </p>
                </v-flex>-->
              </v-flex>
            </div>
            <v-img class="cenefa"
                src="cenefa.png" 
            />          
        </v-img>
        </v-card>
      </v-flex>
      
    </v-layout>


<!-- CIERRA ENCABEZADO -->


<!-- LALABUM EN TU ESCUELA -->

<!-- PC -->

    <v-layout class="hidden-sm-and-down" row wrap  style="background-color:#f7f7f7">
      <v-flex class="pa-2" xs12 sm12 md10 lg10 offset-md1 offset-lg1>
  
        <div align="center" class="hidden-sm-and-down" >
          <p style="font-family:Fredoka one; font-size:2.5vw; color:#568bc3">{{row2_text_title1}}</p>
          
          <video id='my-video' class='video-js'  controls  autoplay  width="900"
                                          :poster='portada_video' data-setup='{}'>
                                            <source :src='urlvideo'>
                                            <p class='vjs-no-js'>
                                              To view this video please enable JavaScript, and consider upgrading to a web browser that
                                              <a :href='urlvideo'></a>
                                            </p>
                                    </video>

          </div>
      </v-flex>
    </v-layout>

  <!-- Movil -->
    <v-layout class="hidden-md-and-up" row wrap style="background-color:#f7f7f7">
      <v-flex class="pa-2 remove-shadow" xs12 sm12 md10 lg10 offset-md1 offset-lg1>
         <div align="center"  >
          <p style="font-family:Fredoka one; font-size:6vw; color:#568bc3">{{row2_text_title1}}</p>
          <video id='my-video' class='video-js'  controls  autoplay  width="350"
                                          :poster='portada_video' data-setup='{}'>
                                            <source :src='urlvideo'>
                                            <p class='vjs-no-js'>
                                              To view this video please enable JavaScript, and consider upgrading to a web browser that
                                              <a :href='urlvideo'></a>
                                            </p>
                                    </video>

          </div> 
      
      </v-flex>
      
    </v-layout>

<!-- CIERRA LALABUM EN TU ESCUELA -->

<!-- CONTENIDO -->

<!-- PC -->

    <v-layout class="hidden-sm-and-down" row wrap>
      <v-flex sm12 md12 >
        <v-card flat dark color="white">        
          <v-img
              src="padres_cover.png"
            >
            <div class="vertical-center">
                <v-layout justify-center>
        <v-flex class="" style="padding:4vw" xs6 sm6 md10 lg10>       
        </v-flex>
        <v-flex class="" style="padding:4vw; " xs6 sm6 md7 lg7>
            <p class="text-center text-guia" style="color:white;font-family:Poppins; font-size:1.7vw; text-align:left; font-weight:500" >{{row2_text1}}</p>
            <p class="text-center text-guia" style="color:white;font-family:Poppins; font-size:1.8vw; text-align:center; font-weight:800" >{{row2_text1_1}}</p>
        </v-flex>    
        </v-layout>

          
            <v-layout justify-center style="margin-top:-100px;" >
        <v-flex  style="padding:4vw" xs2 sm2 md2 lg2>
            <v-img src="dibujos.png"></v-img>   
            <p style="color:white;font-family:Poppins; font-size:1.4vw; text-align:right; font-weight:500">{{row2_text2}}</p>        
        </v-flex>
        <v-flex class="" style="padding:4vw" xs2 sm2 md2 lg2>
            <v-img src="musica.png"></v-img>
            <p style="color:white;font-family:Poppins; font-size:1.4vw; text-align:center; font-weight:500">{{row2_text3}}</p>  
        </v-flex>
        <v-flex class="" style="padding:4vw" xs2 sm2 md2 lg2>
            <v-img src="cuentos.png"></v-img>
            <p style="color:white;font-family:Poppins; font-size:1.4vw; text-align:center; font-weight:500">{{row2_text4}}</p>  
        </v-flex>
        <v-flex class="" style="padding:4vw" xs2 sm2 md2 lg2>
            <v-img src="juegos.png"></v-img>
            <p style="color:white;font-family:Poppins; font-size:1.4vw; text-align:center; font-weight:500"> {{row2_text5}}</p>  
        </v-flex>
        <v-flex class="" style="padding:4vw;" xs2 sm2 md2 lg2>
            <v-img src="videos.png"></v-img>
            <p style="color:white;font-family:Poppins; font-size:1.4vw; text-align:center; font-weight:500">{{row2_text6}}</p>  
        </v-flex>
        </v-layout> 

            </div>
                      
        </v-img>
        </v-card>
      </v-flex> 
    </v-layout>


<!-- Movil -->

 <v-layout row wrap class="hidden-md-and-up">
      <v-flex sm12 md12 >
        <v-card flat dark color="white">        
          <v-img class="header_parents"
              src="opacity_black.png" height="380px"
            >
            <div class="vertical-center-mobile">
              <v-flex xs11 sm11 md4 lg4>
                <p  style="font-size:3.2vw; font-family:Poppins; text-align:center; font-weight:500; margin-top:300px">
                  {{row2_text1}}
                </p>
              </v-flex>
            </div>         
        </v-img>
        </v-card>
      </v-flex>
      
    </v-layout>
    <v-layout row wrap class="hidden-md-and-up">
      <v-flex sm12 md12 >
        <v-card flat dark color="white">        
          <v-img class="header_parents"
              src="blue_movil.png" height="330" 
            >
               <v-flex class="md_screen" xs12 sm12 md10 lg10 offset-md1 offset-lg1 >
        <v-layout justify-center class="iconos">
        <v-flex  style="padding:7vw" xs4 sm4 md2 lg2>
            <v-img src="dibujos.png"></v-img>   
            <p style="font-family:Fredoka one; font-size:3vw; align-text:right">{{row2_text2}}</p>        
        </v-flex>
        <v-flex class="" style="padding:7vw" xs4 sm4 md2 lg2>
            <v-img src="musica.png"></v-img>
            <p style="font-family:Fredoka one; font-size:3vw">{{row2_text3}}</p>  
        </v-flex>
        <v-flex class="" style="padding:7vw" xs4 sm4 md2 lg2>
            <v-img src="cuentos.png"></v-img>
            <p style="font-family:Fredoka one; font-size:3vw">{{row2_text4}}</p>  
        </v-flex>
        </v-layout>
        <v-layout justify-center class="iconos">
        <v-flex class="" style="padding:7vw" xs4 sm4 md2 lg2>
            <v-img src="juegos.png"></v-img>
            <p style="font-family:Fredoka one; font-size:3vw">{{row2_text5}}</p>  
        </v-flex>
        <v-flex class="" style="padding:7vw;" xs4 sm4 md2 lg2>
            <v-img src="videos.png"></v-img>
            <p style="font-family:Fredoka one; font-size:3vw">{{row2_text6}}</p>  
        </v-flex>
        </v-layout>
      
        
      </v-flex> 
        </v-img>
        </v-card>
      </v-flex>
      
    </v-layout>

<!-- CIERRA CONTENIDO -->


<!-- METODOLOGIA -->

<!--PC -->
      <v-layout class="hidden-sm-and-down" style="margin-top:-25px;" row wrap>
      <v-flex sm12 md12 >
        <v-card flat dark color="white">        
          <v-img
              src="met.png"
            >
          
                      
        </v-img>
        </v-card>
      </v-flex> 
    </v-layout>

<!-- Movil -->

 <v-layout class="hidden-md-and-up" style="margin-top:-5px;" row wrap>
      <v-flex sm12 md12 >
        <v-card flat dark color="white">        
          <v-img
              src="met.png"
            >
          
                      
        </v-img>
        </v-card>
      </v-flex> 
    </v-layout>


<!-- CIERRA METODOLOGIA -->

<!-- OBTEN EL PROGRAMA LALABUM PARA TU KINDER -- NUESTRO PROGRAMA INCLUYE -->

      <!-- PC -->
      <v-layout class="hidden-sm-and-down" row wrap>
      <v-flex sm12 md12 >
        <v-card flat dark color="white">        
          <v-img
              src="obten.png"
            >
          
                      
        </v-img>
        </v-card>
      </v-flex> 
    </v-layout>

    <!-- Movil -->
     <v-layout class="hidden-md-and-up"  row wrap>
      <v-flex sm12 md12 >
        <v-card flat dark color="white">        
          <v-img
              src="obten.png"
            >
          
                      
        </v-img>
        </v-card>
      </v-flex> 
    </v-layout>


    <!--ROW6-->
     <!-- Contactanos -->

    <v-layout class="hidden-sm-and-down" row wrap>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat dark color="white">        
          <v-img 
              src="contactanos_ftecnica.png"
            >      
        </v-img>           
            <div class="contacto_escuela">
              <v-flex class="pa-1" xs8 sm8 md8 lg8 >
        <p class="text-center" style="color:white; font-family:Fredoka one; font-weight:400;">{{row6_text1}}</p> <br>

              </v-flex>
        <v-layout justify-center>
        <v-flex xs6 sm6 md8 lg8 >
        <a href='https://calendly.com/lalabum/lalabum' target="_blank" ><img class="img_contact  hidden-sm-and-down" :src="row6_img1"/></a>
        <!-- Contacto -->
      </v-flex>
      <v-flex xs6 sm6 md6 lg6 >
        <v-img  class="img_contactmovil hidden-md-and-up " :src="row6_img1"></v-img>
      </v-flex>
      </v-layout>
            </div>
            
        </v-card>
      </v-flex> 
    </v-layout>

    <!--Contactanos MOBILE-->
   <v-layout justify-center class="hidden-md-and-up" row wrap >
      <v-flex xs12 sm12 md12 lg12>
        <v-card dark color="white">        
          <v-img class="header_parents"
              src="contactanos_ftecnica.png" height="280px"
            >      
        </v-img>       
            <div class="contacto_padres_mobile">
              <v-flex xs11 sm11>
              <p class="text-center" style="margin-top:2%;color:white; font-size:5.6vw!important; font-family:Fredoka one; font-weight:200;">{{row6_text1}}</p>
             </v-flex>
              <v-flex xs9 sm9>
              <a style="text-decoration:none;" href="#">
                <!--<br><v-img slot="badge" @click.stop="dialogcontact = true" style="margin-left: 20%; margin-top:-8%" :src="row6_img1"></v-img>-->
                <br><a href='https://calendly.com/lalabum/lalabum' target="_blank" ><v-img style="margin-left: 20%; margin-top:-8%" :src="row6_img1"></v-img></a>
               <!-- <img slot="badge" @click.stop="dialogcontact = true" class="img_contact  hidden-sm-and-down" :src="row4_img1"/>-->
              </a>
              
              </v-flex>
            </div>
        </v-card>
      </v-flex> 
    </v-layout>

    <a class='hidden-sm-and-down btncontact' href='https://calendly.com/lalabum/lalabum' target="_blank" ><img :src='row6_img1' /></a>
    <a class='hidden-md-and-up btncontact' href='https://calendly.com/lalabum/lalabum' target="_blank"><img :src='row6_img1' width="200"/></a>


  </div>
</template>

<script src='https://vjs.zencdn.net/7.5.4/video.js'></script>
<script type="text/javascript">
var myPlayer = videojs('my-video');
myPlayer.on('timeupdate', function() {
  console.log(this.currentTime());
});
</script>

<script>
import reproductor from "../components/VideoPlayer"



  export default {
	components: {
		reproductor
	},
    
    data() {
    let language=localStorage.getItem('language');
    //echo (language);
    
      if (language=='es-XL' || language=='es') 
      {
        return{  
          dialog:false,      
          dialogvideo:false,
          portada_video:"portada_video.png",
          row1_text1:"La forma de dar clases esta cambiando",
          row1_text2:"Las escuelas se enfrentan a un nuevo reto para el ciclo escolar",
          //row1_img:'cover_esp_ftecnica.png',
          row1_img:"cover_home_maestros.png",
          row1_video:"https://lalabumapp.com/descargas/videos_padres/Lalabum_escuelas.mp4",
          row2_text_title1:"Lalabum en tu escuela",
          
          //row2_text1:'El programa educativo Lalabum es una experiencia interactiva pensada para niños de 3 a 5 años donde a través de recursos multimedia, aplicaciones móviles y actividades didácticas donde ellos puedan prácticar sus valores, estos recursos se basan en promover aprendizajes significativos simulando situaciones de la vida cotidiana para que lleven acabo actitudes positivas en la toma de decisiones de su día a día.',
          row2_text1:"En Lalabum creamos experiencias educativas, con un programa para preescolar que te ofrece continuar la formación de los alumnos dentro y fuera de la escuela, creando un balance entre el uso de la tecnología y el trabajo con libros para desarrollar las habilidades que les sirvan para toda su vida como son los valores y buenas actitudes.",
          row2_text1_1:"¡Une tu escuela al programa Lalabum!",
          row2_text2:'Planeaciones de clase',
          row2_text3:'Canciones',
          row2_text4:'Libros',
          row2_text5:'Apps',
          row2_text6:'Videos',
          //row2_img1:'dispositivos_ftecnica.png',
          row2_img1:"ftecnica_presentacion_Mesa_de_trabajo.png",
          row3_text1:'¿Por qué Lalabum?',
          row3_text2:'Nos especializamos en la enseñanza de valores para la nueva generación de líderes',
          row3_text3:'Nuestra metodología ofrece un balance entre el tiempo en pantalla y divertidas actividades que pueden compartir los niños en casa y en el salón de clases.',
          row3_text4:'Los valores que se promueven en la metodología Lalabum son:',
          row3_img1:'valores_0001_esp.png',
          row4_text1:'Sé parte del Programa Educativo y obtén:',
          //row4_img1:'IMG_0003_1_ESP.png',
          //row4_img2:'IMG_0002_2_ESP.png',
          row4_img1:"maestras.png",
          row4_img2:"padres.png",
          kit_lalabum1:'Actividades y juegos coloreables para',
          kit_lalabum2:'prácticar valores en cada grado preescolar',
          kit_lalabum3:'La tarjeta Lalabum incluye un código en',
          kit_lalabum4:'el cual podrás descargar nuestra app',
          kit_lalabum3_movil:'La tarjeta Lalabum incluye un',
          kit_lalabum4_movil:'código en el cual podrás',
          kit_lalabum5_movil:'descargar nuestra app',
          kit_lalabumapp:'appeducativa_icono.png',
          kit_lalabumamazon:'comprar_kit.png',
          row6_text1:'¿Diriges una escuela y te interesa el programa Lalabum?',
          row6_img1:'contactanos1.png',
          //row1_text1:'Contáctanos',
          valid: true,          
          contact_name: '',
          nameRules: [
            v => !!v || 'Name is required',
            v => (v && v.length <= 10) || 'Name must be less than 10 characters'
          ],
          contact_email: '',
          emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+/.test(v) || 'E-mail must be valid'
          ],
          school:'',
          Message:'',
          select:'',        
          titulovideo:"Lalabum Escuelas" ,
          urlvideo:"https://lalabumapp.com/descargas/videos_padres/Lalabum_escuelas.mp4",
          img:""


        }
      } else {
        return{      
          dialog:false,
          portada_video:"portada_video.png",
          row1_img:'cover_eng_ftecnica.png',
          row2_text_title1:"Values ​​educational program",
          row2_text_title2:"for preschool",
          padres:"COVER_PADRES.png",
          //row2_text1:'Lalabum educational program is an interactive experience designed for children from 3 to 5, with multimedia resources, mobile applications and didactic activities that help them practice their values, these resources are based on promoting significant learning by simulating everyday situations so they carry out positive attitudes into day to day decision making.',
          //row2_text1:"The way of teaching is changing, schools face new challenges for the next school year. At Lalabum we create educational experiences, with a preschool program that offers you to continue the training of students in and out of school, creating a balance between the use of technology and work with books to develop the skills that serve them for all his life as are the values ​​and good attitudes. The Lalabum program is an educational solution for your preschool classes for the next school year. Join your school to the Lalabum program!",
          row2_text2:'Drawings',
          row2_text3:'Songs',
          row2_text4:'Stories',
          row2_text5:'Games',
          row2_text6:'Videos',
          row2_img1:'ftecnica_presentacion_Mesa_de_trabajo.png',
          row3_text1:'¿Why Lalabum?',
          row3_text2:'We specialize in teaching values for the new generation of leaders.',
          row3_text3:'Our methodology offers a balance between screen time and fun activities that children can share at home and in the classroom.',
          row3_text4:"The values ​​promoted in Lalabum's methodology are:",
          row3_img1:'valores_0000_eng.png',
          row4_text1:"Be part of Lalabum's Experience and obtain:",
          //row4_img1:'IMG_0001_1_ENG.png',
          row4_img1:"teachers.png",
          row4_img2:"parents.png",
          //row4_img2:'IMG_0000_2_ENG.png',
          kit_lalabum1:'Coloring, cut out and jigsaw didactic games develop social and emotional skills.',
          kit_lalabum3:"The lalabum card includes a scratc off code to unlock lalabum's world app",
          kit_lalabum3_movil:"The lalabum card includes ",
          kit_lalabum4_movil:"a scratc off code to unlock",
          kit_lalabum5_movil:"lalabum's world app",
          kit_lalabumapp:'educationalapp_icon.png',
          kit_lalabumamazon:'buy_kit.png',
          row6_text1:'¿Do you run a school and you are interested in the Lalabum program?',
          row6_img1:'contactus1.png',
          valid: true,          
          contact_name: '',
          nameRules: [
            v => !!v || 'Name is required',
            v => (v && v.length <= 10) || 'Name must be less than 10 characters'
          ],
          contact_email: '',
          emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+/.test(v) || 'E-mail must be valid'
          ],
          school:'',
          Message:'',
          select:'',  
          titulovideo:"Lalabum Escuelas" ,
          urlvideo:"https://lalabumapp.com/descargas/videos_padres/Lalabum_escuelas.mp4",
          img:""
        }
      }      
    },
    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
          this.sendContact()
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
       sendContact: function () {     
        let name = this.contact_name;
        let email = this.contact_email;        
        let message = this.Message;
        let type = this.select;
        let school = this.school;
        this.$store.dispatch('send_mail', {name,email, message,type,school})
       .then( function () {
          alert("Correo enviado con exito");
          window.location.href="https://www.lalabumapp.com/home";
       }  
       ).catch(function () {
          alert("Usuario/Contraseña incorrecto");
       }
       )
      }
    }
    
  }

</script>
<style>
/* Fuentes */
@import url('https://fonts.googleapis.com/css?family=Fredoka+One|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i');


/* Movil */
@media screen and (max-width: 400px) {

  .contacto_escuela{
    top: 45%;
    color: white;
  }

  .img_contactmovil{
  left: -45%;
  top: -70%;
}

.md_screen p{
   font-size: 1.8vw;
  }

}

/* PC */
@media screen and (min-width: 960px) {
  .contacto_escuela p{
  
    color: white;
  }

  .contacto_escuela{
    top:30%;
  }

  .img_contact{
    margin-left: 17%;
  }

  
}

/*Encabezado*/

.cenefa{    
  top: 88%;
}




.vertical-center{
  padding-left:10%;
  margin: 0px;
  position:absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.text-top-row{
  font-size:2.2vw;
  font-family: 'Fredoka One', cursive;
  
}

/* ---- */

/* ROW2 Progama Lalabum*/
.text-center{
  font-size:2.3vw;
  /*padding-top: 2vw;*/
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  color: #568BC3;
}

.sub, .text-guia{
  font-weight: 400;
  color: gray;
  font-size:2vw;
}

.iconos{
  color:white;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  text-align: center;
}

/* ---- */

/* Lala caja */
.include{
font-family: 'Poppins', sans-serif;
}

.include1 li{
font-family: 'Poppins', sans-serif;
font-size: 1.5vw;
}
/* ---- */

/* Contactanos */
.contacto_escuela{
  padding-left:28%;
  margin: 0px;
  position:absolute;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  text-align: center;
}

.contacto_padres_mobile{
  padding-left:6%;
  margin: 0px;
  top:40%;
  position:absolute;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  text-align: center;
}

.btncontact{
        display:scroll;
        position:fixed;
        bottom:0px;
        right:0px;
        z-index:100;
        margin-right: 0px;
    }

    .vertical-center-mobile{
  padding-left:4%;
  margin: 0px;
  position:absolute;
  top: 35%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.text-top-row{
  font-size:2.3vw;
  font-family: 'Fredoka One', cursive;
  
}


/* ---- */

</style>